<template>
  <div class="modal-backdrop" @click.self="$emit('cancel')" @keydown.esc="$emit('cancel')">
    <section class="modal-panel" role="dialog" aria-modal="true" :aria-labelledby="titleId">
      <header class="modal-header">
        <h2 :id="titleId" class="modal-title">{{ title }}</h2>
        <button type="button" class="icon-button modal-close" aria-label="Close" @click="$emit('cancel')">
          <X class="icon" />
        </button>
      </header>
      <form class="modal-form" @submit.prevent="submit">
        <div class="modal-body">
          <label class="modal-field">
            <span class="modal-field-label">{{ label }}</span>
            <input
              ref="inputEl"
              v-model="value"
              type="text"
              class="text-input"
              autocomplete="off"
              spellcheck="false"
            />
          </label>
        </div>
        <footer class="modal-footer">
          <button type="button" class="btn btn-ghost" @click="$emit('cancel')">Cancel</button>
          <button type="submit" class="btn btn-primary" :disabled="!canSubmit">{{ confirmLabel }}</button>
        </footer>
      </form>
    </section>
  </div>
</template>

<script setup lang="ts">
import { X } from 'lucide-vue-next';
import { computed, onMounted, ref, useId } from 'vue';

const props = defineProps<{
  title: string;
  label: string;
  confirmLabel: string;
  initialValue?: string;
}>();

const emit = defineEmits<{
  confirm: [value: string];
  cancel: [];
}>();

const titleId = useId();

const value = ref(props.initialValue ?? '');
const inputEl = ref<HTMLInputElement | null>(null);

const canSubmit = computed(() => value.value.trim().length > 0);

onMounted(() => {
  const el = inputEl.value;
  if (!el) {
    return;
  }

  el.focus();
  el.select();
});

function submit(): void {
  if (!canSubmit.value) {
    return;
  }

  emit('confirm', value.value.trim());
}
</script>
